<template>
  <article>
    <header class="view__header">
      <h2 class="view__title">{{ title }}</h2>
    </header>
    <article class="view__content">
      <div class="view__panel">
        <div class="form js-form">
          <submenu v-if="this.$route.params.id"></submenu>
          <div class="options-list">
            <div class="options-list__item" v-for="option in paymentOptions">
              <div class="options-list__content">
                <h2 class="options-list__title">{{ option.name }}</h2>
              </div>
              <div class="options-list__control" data-acc="toggle">
                <input data-acc="input" v-on:click="toggle(option.id)" v-model="currentPaymentOptions" :value="option.id" :id="option.id" class="options-list__checkbox" type="checkbox">
                <label class="options-list__toggle" :for="option.id"></label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </article>

  </article>
</template>

<script>
import { CheckBox } from 'components/layout/forms'
import Submenu from 'components/views/groups/Submenu'
import L from 'services/Localization'
import { mapGetters } from 'vuex'
import notifications from 'mixins/notifications'
import _ from 'lodash'

export default {
  name: 'group-payment-options',
  components: { Submenu, CheckBox },
  mixins: [notifications],
  data() {
    return {
      L: L
    }
  },
  beforeCreate() {
    this.$store.dispatch('getGroup', this.$route.params.id)
    this.$store.dispatch('getPaymentOptions')
  },
  computed: {
    ...mapGetters({
      group: 'activeGroup',
      paymentOptions: 'allPaymentOptions'
    }),
    title() {
      return this.group.name
    },
    currentPaymentOptions() {
      if (this.group && this.group.paymentOptions != null) {
        return this.group.paymentOptions.map(paymentOption => { return paymentOption.id })
      }
      return []
    }
  },
  methods: {
    toggle(paymentOptionId) {
      let options = this.currentPaymentOptions
      if (_.includes(options, paymentOptionId)) {
        options.splice(options.indexOf(paymentOptionId), 1)
      } else {
        options.push(paymentOptionId)
      }
      this.$store.dispatch('setPaymentOptions', { id: this.group.id, paymentOptionIds: options })
        .then(() => {
          this.showNotification({
            title: L.localize('Label_SuccessEdit'),
            message: L.localize('Label_Success')
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// GroupPaymentOptions.vue?16603b08